import React from 'react';
import { packItems } from '../data/content';
import { icons } from '../utils/icons';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-242" data-mp="kx13jx65c41w">
      <div className="mx-auto max-w-6xl" data-id="element-243" data-mp="pv2l2dnxbvb9">
        <SectionHeading eyebrow="Dentro del kit" title={<>
              ¿Qué incluye tu{' '}
              <span className="text-brand" data-id="element-245" data-mp="b5mxf6jow5zs">Kit de Ejecución Directa</span>?
            </>} subtitle="Doce volúmenes de material curricular que cubren el ciclo escolar completo, desde el Lesson Plan para el docente hasta el Student’s Worksheet final." data-id="element-244" data-mp="pu1asbeqfcul" />

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-246" data-mp="74l5las3qw7u">
          {packItems.map((item, index) => {
          const Icon = icons[item.icon];
          return <Reveal key={item.title} delay={index * 0.04} className="h-full" data-id="element-247" data-mp="3odq7dbecgznv" data-mpi={index}>
                <li className="flex h-full flex-col rounded-2xl border-2 border-ink bg-white p-7 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-248" data-mp="3taq6t3gov460">
                  <div className="flex items-center justify-between" data-id="element-249" data-mp="37vcj6usqfpcz">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-ink text-volt" data-id="element-250" data-mp="37x7449407hh2">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-251" data-mp="3hta87kif1q6n" />
                    </span>
                    <span className="font-display text-2xl text-ink/10" data-id="element-252" data-mp="2u36fw9aohcuy">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-xl leading-tight text-ink" data-id="element-253" data-mp="2p2id6qd377kw">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-ink/70" data-id="element-254" data-mp="2y4rmjcwmcuwp">
                    {item.text}
                  </p>
                </li>
              </Reveal>;
        })}

          <Reveal delay={0.2} className="h-full" data-id="element-255" data-mp="26e3rmiljglrh">
            <li className="flex h-full flex-col justify-center rounded-2xl border-2 border-ink bg-volt p-8" data-id="element-256" data-mp="26dljanllqh37">
              <p className="font-display text-sm tracking-[0.14em] text-ink/60" data-id="element-257" data-mp="9b4xhbrk15gn">
                Master Plan
              </p>
              <p className="mt-3 font-display text-4xl leading-none text-ink" data-id="element-258" data-mp="j30zgxwrhfq5">
                Todo listo para ejecutar
              </p>
              <p className="mt-4 text-base leading-relaxed text-ink/75" data-id="element-259" data-mp="o12hdfigb901">
                Sin preparar material, sin traducir consignas y sin improvisar:
                abres el tomo del nivel y entras al aula.
              </p>
            </li>
          </Reveal>
        </ul>
      </div>
    </section>;
}